/**
 * Вставка `displayCode` ставки RTB в документ страницы.
 *
 * Это не баннер, а вызов smi-информера (`smi.js` + `smiq.push`): он сам
 * позиционируется, считает видимость и отстукивает биллинг из контекста страницы,
 * поэтому в iframe его не завернуть. Скрипты, вставленные через `innerHTML`, браузер
 * не исполняет, поэтому каждый `<script>` пересоздаётся через `createElement` с теми
 * же атрибутами и текстом. Код вендора не меняется и не фильтруется.
 */
export function recreateScripts(root, doc) {
    const scripts = Array.prototype.slice.call(root.querySelectorAll("script"));

    scripts.forEach((original) => {
        const fresh = doc.createElement("script");

        Array.prototype.forEach.call(original.attributes, (attribute) => {
            fresh.setAttribute(attribute.name, attribute.value);
        });
        fresh.text = original.textContent;

        original.parentNode.replaceChild(fresh, original);
    });

    return scripts.length;
}

export function insertDisplayCode(container, displayCode, doc = document) {
    const template = doc.createElement("template");
    template.innerHTML = displayCode;

    recreateScripts(template.content, doc);
    container.appendChild(template.content);
}
